<script setup lang="ts">
import { CartItem } from '@caks/shared/types/types.user'
import { useAccountStore } from '!/shared/store/store.account'
import { computed } from 'vue'

const props = defineProps<{
  product: CartItem
  cost: number
}>()
const store = useAccountStore()

const count = computed(() => {
  let count = 0
  if (!store.estimate) return ''

  store.estimate.items_in_order.forEach((item) => {
    if (item.id === props.product.item.id) {
      count = props.product.amount
      return count
    }
  })

  return count
})
</script>

<template>
  <div class="order-list__product product">
    <img :src="product.item.main_media" alt="product-image" class="product__image" />
    <div class="product__info">
      <h5>{{ product.item.name }}</h5>
      <p><span>Количество: </span>{{ count }}</p>
      <ul class="product__modifications">
        <li v-for="item in product.extraModificators" :key="item.modification_id">
          <p>{{ item.name }}</p>
        </li>
      </ul>
      <ul class="product__modifications food__modifications_removed">
        <li v-for="item in product.removedModificators" :key="item.modification_id">
          <p>{{ item.name }}</p>
        </li>
      </ul>
    </div>
    <p class="product__price">{{ cost }}₽</p>
  </div>
</template>

<style scoped lang="scss">
.product {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  @include h5-2;

  &__image {
    width: 56px;
    height: 56px;
  }

  &__info {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    max-width: 274px;
    color: $sub-text;

    h5 {
      color: $primary-text;
    }
  }

  &__modifications {
    @include h7-1;
    margin: 2px 0 0;
    color: $primary-green;

    &_removed {
      color: $primary-red;
      margin: 2px 0 12px;
    }
  }
}
</style>
